export interface Rating {
  current: number;
  default: number;
}

export const DefaultRating: Rating = {
  current: 0,
  default: 0
};
